import React from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalConfig } from "./authConfig"; // Ensure correct path to authConfig
import "./index.css";

// Create an instance of MSAL PublicClientApplication
const msalInstance = new PublicClientApplication(msalConfig);

// Get the root container element where the React app will render
const container = document.getElementById("root");

// Create a root for React rendering
const root = createRoot(container);

// Render the application inside MsalProvider to integrate MSAL with React
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
